<onyx-modal
  variant="center"
  [size]="980"
  [showTopBar]="false"
  [showBottomBar]="false"
  [close$]="close$"
  (closeModal)="dialogRef.close()"
>
  @if (selectedItemData(); as data) {
    <div class="container">
      <div class="thumbnail-container">
        @if (selectedIndex() > 0) {
          <onyx-icon-button
            class="up"
            variant="ghost"
            color="black"
            [size]="32"
            icon="arrow-alt-up-outlined"
            [circle]="true"
            (click)="previous(); $event.stopPropagation()"
          ></onyx-icon-button>
        }

        <div class="thumbnails">
          @for (item of items(); track item.uuid) {
            <div
              #thumbnailElement
              class="thumbnail"
              [class.active]="$index === selectedIndex()"
              [style.background-image]="`url('${item.thumbnail}')`"
              tabindex="-1"
              (keydown.enter)="(null)"
              (mouseenter)="selectImage(item.image); $event.stopPropagation()"
            ></div>
          }
        </div>

        @if (selectedIndex() !== items().length - 1) {
          <onyx-icon-button
            class="down"
            variant="ghost"
            color="black"
            [size]="32"
            icon="arrow-alt-down-outlined"
            [circle]="true"
            (click)="next(); $event.stopPropagation()"
          ></onyx-icon-button>
        }
      </div>

      <div
        class="main-image"
        [style.background-image]="`url('${data.thumbnail}')`"
      ></div>

      <div class="information">
        <div class="heading">
          <p class="f-body-l f-semibold">
            {{ data.title | translate }}
          </p>

          <div class="f-body-l">
            @if (data.note; as note) {
              {{ note }}
            } @else {
              <span class="f-muted">
                {{ 'labels.missingNote' | translate }}
              </span>
            }
          </div>
        </div>

        <div class="buttons">
          <onyx-button
            variant="outlined"
            [size]="32"
            leftIcon="download-outlined"
            (click)="data.image ? actionHelper.downloadFile(data.image!) : null"
          >
            {{ 'labels.download' | translate }}
          </onyx-button>

          <onyx-button
            variant="outlined"
            [size]="32"
            leftIcon="download-outlined"
            (click)="downloadFiles()"
          >
            {{ 'labels.downloadAll' | translate }} ({{ allFiles().length }})
          </onyx-button>
        </div>
      </div>
    </div>
  }
</onyx-modal>
